<!-- components/ui/ConfirmModal.vue -->
<template>
    <UModal v-model="state.isOpen">
      <UCard :ui="{ divide: 'divide-y divide-gray-100 dark:divide-gray-800' }">
        <template #header>
          <div class="flex items-center justify-between">
            <h3 class="text-base font-semibold leading-6 text-gray-900 dark:text-white">
              {{ state.title }}
            </h3>
          </div>
        </template>
  
        <div class="py-4">
          {{ state.text }}
        </div>
  
        <template #footer>
          <div class="flex justify-end gap-3">
            
            <UButton
              :color="options?.cancel_button?.color"
              :variant="options?.cancel_button?.variant"
              :size="options?.cancel_button?.size"
              :label="options?.cancel_button?.text"
              @click="handleResult(false)"
            />

            <UButton
              :color="options?.confirm_button?.color"
              :variant="options?.confirm_button?.variant"
              :size="options?.confirm_button?.size"
              :label="options?.confirm_button?.text"
              @click="handleResult(true)"
            />
            
          </div>
        </template>
      </UCard>
    </UModal>
  </template>
  
  <script setup lang="ts">
  const state = useConfirmModalState()

  let options = {
    confirm_button: {
      text: 'Подтвердить',
      color: 'primary',
      variant: 'solid',
      size: 'md',
    },
    cancel_button: {
      text: 'Отмена',
      color: 'gray',
      variant: 'soft',
      size: 'md',
    },
  }
  
  const handleResult = (result: boolean) => {
    if (state.value.callback) {
      state.value.callback(result)
    }
    state.value.isOpen = false
    state.value.callback = null
  }
  </script>